import React from 'react';
import { useTranslation } from './localization';

// Same-origin, user-initiated playback: no third-party player or eager video download.
export default function ProductDemo({ compact = false, id, videoRef }) {
  const tr = useTranslation();
  return <section id={id} className={`product-demo${compact ? ' product-demo-compact' : ''}`} aria-label={tr('See EarlyBird in action.')}>
    <div className="product-demo-heading"><span className="eyebrow">{tr('44-second demo · English on-screen text')}</span><h2>{tr('See EarlyBird in action.')}</h2><p>{tr('Watch a real account narrow its feed and review a job before applying.')}</p></div>
    <video ref={videoRef} id={id ? `${id}-video` : undefined} tabIndex={0} controls playsInline preload="none" poster="/demos/workflow-20261005-poster.png" width="1920" height="1080" aria-label={tr('See EarlyBird in action.')}>
      <source src="/demos/workflow-20261005.mp4" type="video/mp4" />
    </video>
    <p className="product-demo-caption">{tr('Real account, captured 5 October 2026. Opportunities and results vary.')}</p>
    <details><summary>{tr('Read the walkthrough')}<span aria-hidden="true">+</span></summary><ol>
      <li>{tr('Choose your skills and separate fixed-price and hourly minimums.')}</li>
      <li>{tr('Filter the dashboard by skill and job type. Compare budgets in the same units.')}</li>
      <li>{tr('Open a job to review its full budget range and requirements on Upwork.')}</li>
      <li>{tr('After checkout, save your alert settings to receive new opportunities by email, Telegram or Slack.')}</li>
    </ol></details>
  </section>;
}
